import { IoSearch } from 'react-icons/io5';

import Container from '@/components/@base/container';
import { Heading, Text } from '@/components/@base/typography';
import { HEADING_TYPE } from '@/components/@base/typography/heading/type';

import localization from '@/constant/localization';

export default function NoResult() {
  return (
    <Container center className='min-h-[50vh] w-full flex-col'>
      <Container
        center
        className='mb-[18px] h-[54px] w-[54px] rounded-full bg-[linear-gradient(180deg,_#A2B3CD_0%,_#878F9B_100%)]'
      >
        <IoSearch size={22} fill='#E5E8EB' />
      </Container>
      <Heading type={HEADING_TYPE.H5} className='mb-1.5 text-lg font-bold text-[#424244]'>
        {localization.notFoundAnyResult}
      </Heading>
      <Text className='text-[13px] text-[#76767C]'>
        {localization.tryAgainOrUseOtherFilters}
      </Text>
    </Container>
  );
}
